import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { consentStatusSchema, type ConsentStatus } from '@tg-hookah/shared';
import { api } from '@/lib/api';

const QUERY_KEY = ['me', 'consent'] as const;

export function useConsentStatus(enabled: boolean) {
  return useQuery({
    queryKey: QUERY_KEY,
    enabled,
    queryFn: async (): Promise<ConsentStatus> => {
      const res = await api.get('/me/consent');
      return consentStatusSchema.parse(res.data);
    },
  });
}

export function useAcceptConsent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (version: string) => {
      // Send back the exact version the server told us about — the API
      // rejects stale versions so a mid-session bump triggers a fresh status
      // round-trip and re-renders the gate.
      const res = await api.post('/me/consent', { version });
      return consentStatusSchema.parse(res.data);
    },
    onSuccess: (data) => {
      qc.setQueryData(QUERY_KEY, data);
    },
    onError: () => {
      // The most likely failure is a stale version (admin bumped while the
      // user was on the gate) — refetch so the next click sends the new one.
      void qc.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
